export const snackMessages = {
  googleSuccess: "You've just signed in Google",
  googleError: "Google signin unsuccessful. Try again",
  signup: "Signup Successful! Welcome onboard",
  signupFail: "Signup failed. Please, try again",
  signin: "You've successfully signed in",
  signinFail: "Oops, Signin unsuccessful. Invalid credentials",
  logout: "Logged out! You need to login again",
  fetchPost: "We couldn't fetch our post. Please refresh.",
  createPost: "Post Created!",
  createPostFail: "Oops, couldn't create post. Try again",
  updatePost: "Post Updated!",
  updatePostFail: "Oops, couldn't update post. Try again",
  forgotPasswordFail: "Oops, email not sent",
  forgotPasswordSuccess: "Email sent. Check your email",
  resetPasswordSuccess: "Password reset successful",
  resetPasswordError: "Password reset unsuccessful",
  deletePost: "Post deleted",
  deletePostFail: "Oops, couldn't delete this post. Try again",
  likePost: "Liked",
  likePostFail: "Oops, couldn't like this post. Try again",
  isUser: "You really need to sign in now",
  unauthorized: "Oops, this is not your post",
};
